<ui-dialog
    size="small"
    [isCloseable]="false"
    [open]="openDialog"
    [header]="editMode ? 'applicant-tracker.editQuestion' : 'applicant-tracker.addAQuestion'"
>
    <!-- Loader -->
    <div *ngIf="isLoading" class="ui active inverted dimmer">
        <div class="ui loader"></div>
    </div>

    <form class="app-grid" #form="ngForm">
        <!-- Question Type-->
        <mat-form-field class="columns-6">
            <mat-label appRemoveAriaOwns>{{ 'applicant-tracker.questionType' | translate }}</mat-label>
            <mat-select
                [(ngModel)]="selectedQuestionType"
                (selectionChange)="onQuestionTypeSelected()"
                name="selectedQuestionType"
                required
            >
                <mat-select-trigger *ngIf="selectedQuestionType">
                    {{ selectedQuestionType | appTranslateOptions: interviewQuestionDisplay }}
                </mat-select-trigger>

                <mat-option
                    style="height: 100%"
                    [value]="applicantInterviewQuestionTypesEnum.multipleChoice"
                    class="margin-bottom-1"
                    ><div class="question-type-title">
                        {{ 'applicant-tracker.questionTypes.multipleChoice' | translate }}
                    </div>
                    <div class="question-type-info">
                        {{ 'applicant-tracker.questionTypes.askAQuestionWithMultipleAnswerChoices' | translate }}
                    </div></mat-option
                >
                <mat-option [value]="applicantInterviewQuestionTypesEnum.opinionScale" class="margin-bottom-1"
                    ><div class="question-type-title">
                        {{ 'applicant-tracker.questionTypes.opinionScale' | translate }}
                    </div>
                    <div class="question-type-info">
                        {{ 'applicant-tracker.questionTypes.measureOpinionWithRatingScale' | translate }}
                    </div></mat-option
                >
                <mat-option [value]="applicantInterviewQuestionTypesEnum.openQuestion" class="margin-bottom-1"
                    ><div class="question-type-title">
                        {{ 'applicant-tracker.questionTypes.openQuestion' | translate }}
                    </div>
                    <div class="question-type-info">
                        {{ 'applicant-tracker.questionTypes.forDetailedResponses' | translate }}
                    </div></mat-option
                >
                <mat-option [value]="applicantInterviewQuestionTypesEnum.yesNo" class="margin-bottom-1"
                    ><div class="question-type-title">{{ 'applicant-tracker.questionTypes.yesNo' | translate }}</div>
                    <div class="question-type-info">
                        {{ 'applicant-tracker.questionTypes.forJustTwoOptions' | translate }}
                    </div></mat-option
                >
            </mat-select>
        </mat-form-field>

        <!-- Interview Question-->
        <mat-form-field class="columns-12">
            <mat-label>{{ 'applicant-tracker.interviewQuestion' | translate }}</mat-label>
            <input
                name="interviewQuestion"
                type="text"
                [(ngModel)]="interviewQuestion.question"
                required
                matInput
                #questionInput="ngModel"
                maxlength="255"
            />
            <mat-hint align="end">{{ interviewQuestion.question?.length || 0 }}/255</mat-hint>
            <mat-error *ngIf="questionInput.errors?.['maxlength']">
                {{ 'applicant-tracker.questionMaxLengthExceeded' | translate }}
            </mat-error>
        </mat-form-field>
        <mat-checkbox
            class="columns-12 margin-bottom-2 interview-question-checkbox"
            [(ngModel)]="interviewQuestion.isRequired"
            name="interviewQuestionRequired"
            type="checkbox"
        >
            {{ 'applicant-tracker.thisIsARequiredQuestion' | translate }}
        </mat-checkbox>

        <!-- Multiple Choice Question Type-->
        <div *ngIf="selectedQuestionType === applicantInterviewQuestionTypesEnum.multipleChoice && questionValues">
            <div class="app-grid margin-top-1">
                <mat-label class="margin-bottom-1">{{
                    'applicant-tracker.multipleChoiceOptions' | translate
                }}</mat-label>

                <mat-radio-group
                    [(ngModel)]="questionTypeMode"
                    class="columns-6"
                    class="vertical"
                    name="multipleChoiceOptions"
                    required
                >
                    <mat-radio-button
                        [value]="jobPostingInterviewMultipleChoiceTypes.singleSelect"
                        class="margin-bottom-2"
                        required
                        >{{ 'applicant-tracker.singleSelect' | translate }}</mat-radio-button
                    >

                    <mat-radio-button
                        [value]="jobPostingInterviewMultipleChoiceTypes.multiSelect"
                        class="margin-bottom-2"
                        required
                        >{{ 'applicant-tracker.multipleSelect' | translate }}</mat-radio-button
                    >
                </mat-radio-group>
            </div>

            <div class="columns-6 app-grid margin-top-1">
                <div
                    *ngFor="let value of questionValues; let i = index; trackBy: trackByQuestionValuesId"
                    class="no-top-padding app-grid"
                >
                    <mat-form-field class="columns-9" [class.remove-top-margin]="i !== 0">
                        <mat-label *ngIf="i === 0">{{ 'applicant-tracker.choices' | translate }}</mat-label>
                        <input type="text" matInput [(ngModel)]="questionValues[i]" [name]="'value-' + i" required />
                    </mat-form-field>
                    <div
                        *ngIf="questionValues.length > 2"
                        (click)="onRemoveChoice(i)"
                        class="columns-3 remove-choice"
                        [ngClass]="i === 0 ? 'padding-top-4' : 'padding-top-1'"
                    >
                        <mat-icon svgIcon="close" aria-hidden="true"></mat-icon>
                        {{ 'applicant-tracker.remove' | translate }}
                    </div>
                </div>

                <ui-button
                    *ngIf="questionValues.length < 6"
                    (click)="onAddQuestionValue()"
                    class="columns-12"
                    type="link"
                >
                    <mat-icon svgIcon="plus" aria-hidden="true"></mat-icon>
                    {{ 'applicant-tracker.addChoice' | translate }}
                </ui-button>
            </div>
        </div>

        <!-- Opinion Scale Question Type-->
        <div *ngIf="selectedQuestionType === applicantInterviewQuestionTypesEnum.opinionScale && questionValues">
            <div class="app-grid margin-top-1">
                <mat-label class="margin-bottom-1">{{ 'applicant-tracker.scaleType' | translate }} </mat-label>

                <mat-radio-group
                    (ngModelChange)="onScaleTypeChange()"
                    [(ngModel)]="questionTypeMode"
                    class="columns-6 vertical"
                    name="opinionScaleType"
                    required
                >
                    <mat-radio-button
                        [value]="jobPostingInterviewOpinionScaleTypes.numerical"
                        class="margin-bottom-2"
                        required
                        >{{ 'applicant-tracker.numerical' | translate }}</mat-radio-button
                    >

                    <mat-radio-button
                        [value]="jobPostingInterviewOpinionScaleTypes.stars"
                        class="margin-bottom-2"
                        required
                        >{{ 'applicant-tracker.stars' | translate }}</mat-radio-button
                    >
                </mat-radio-group>
            </div>

            <div class="margin-top-1">
                <div *ngIf="questionTypeMode === jobPostingInterviewOpinionScaleTypes.stars" class="opinion-stars-type">
                    <div *ngFor="let _ of opinionScaleStars; let i = index">
                        <img style="width: 100%" src="/assets/icons/stars/star-default.svg" />

                        <mat-form-field *ngIf="i === 0 || i === 2 || i === 4">
                            <input
                                type="text"
                                matInput
                                [(ngModel)]="questionValues[getQuestionValueIndex(i)]"
                                [name]="'value-' + i"
                                [required]="i !== 2"
                            />
                        </mat-form-field>
                    </div>
                </div>

                <div
                    class="opinion-numerical-type"
                    *ngIf="questionTypeMode === jobPostingInterviewOpinionScaleTypes.numerical"
                >
                    <div *ngFor="let number of opinionScaleNumbers; let i = index">
                        <h3 style="width: 100%">{{ number }}</h3>

                        <mat-form-field *ngIf="i === 0 || i === 2 || i === 4">
                            <input
                                type="text"
                                matInput
                                [(ngModel)]="questionValues[getQuestionValueIndex(i)]"
                                [name]="'value-' + i"
                                [required]="i !== 2"
                            />
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="onCancel()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="primary" [disabled]="isAddQuestionsButtonDisabled(form)" (click)="onAddQuestion(form)">
            {{ (editMode ? 'save' : 'add') | translate }}</ui-button
        >
    </ui-dialog-footer>
</ui-dialog>
